// extracted by mini-css-extract-plugin
module.exports = {"text_input":"text-input_text_input__2Pdy8","text":"text-input_text__1XqYG"};